import { Center, Stack } from '@mantine/core';
import { Icon, Text } from '@repo/foundations';

export function ViolationTableEmptyState() {
	return (
		<Center p="xl">
			<Stack align="center" p="md">
				<Icon name="circleCheck" size="md" color="icon/success/default" />
				<Text size="sm">No violations for this policy</Text>
			</Stack>
		</Center>
	);
}
